import { render } from "./QuestionTypeForm.vue?vue&type=template&id=72fbd2d2&scoped=true"
import script from "./QuestionTypeForm.vue?vue&type=script&lang=js"
export * from "./QuestionTypeForm.vue?vue&type=script&lang=js"

import "./QuestionTypeForm.vue?vue&type=style&index=0&id=72fbd2d2&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fbd2d2"]])

export default __exports__